<template>
  <div class="LC_progress" ref="LC_progress">
    <div class="lookMore">
      <!-- 查看全部 ☰ -->
    </div>
    <el-collapse v-model="activeName" accordion>
      <el-collapse-item :name="i" v-for="(item,i) in dataList" :key="i">
        <template #title>
          <div class="titleLine">
            <div class="leftTitle">{{getName(item.state)}}</div>
            <div class="rightTitleBox">
              <div class="rightTitle">降碳<span>{{item.totalPlannedEmission}}</span>{{item.unit}}</div>
              <div class="rightTitle rightTitle2">减污<span>{{item.totalPlanPollutantEmissions}}</span>{{item.pollutantUnit}}</div>
            </div>
          </div>
        </template>
        <div class="rowBox" v-for="(item_,j) in item.measureItemList" :key="j" @click="openDetail(item_)">
          <div class="rowTitle">{{item_.measureName}}</div>
          <div class="rowView">
            <div class="line1">
              <div class="r1"><span class="number">{{item_.itemState=='完成'?'100%':item_.progress}}</span><span class="status">{{item_.itemState}}</span></div>
              <div class="l1box">
                <div class="l1">
                  计划减排<span class="number">{{item_.plannedEmission}}</span><span>{{item_.unit}}</span>
                </div>
                <div class="l1 l1_">
                  计划减污<span class="number">{{item_.planPollutantEmissions}}</span><span>{{item_.pollutantUnit}}</span>
                </div>
              </div>
            </div>
            <div class="rowBottom">
              <div class="allProgressLine">
                <div class="alreadyLine" :style="{width:item_.progress?item_.progress: item_.itemState=='完成'?'100%':'0%'}"></div>
              </div>
            </div>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import progressDetailPage from "./components/progressDetailPage.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    // lowCarbonPopup2,
  },
  props: ["matrix", "x", "y", "processId"],
  data() {
    //这里存放数据
    return {
      customerId: this.$store.state.customerId,
      activeName: 0,
      dataList: [],
    };
  },
  //计算属性 类似于data概念
  computed: {
    getName() {
      return (status) => {
        if (status == 1) {
          return "实施中";
        } else if (status == 2) {
          return "已完成";
        } else if (status == 3) {
          return "计划中";
        } else {
          return "未知状态";
        }
      };
    },
    ...mapGetters({
      dialogCompontent: "getDialogCompontent",
    }),
  },
  //监控data中的数据变化
  watch: {
    processId: {
      //深度监听，可监听到对象、数组的变化
      handler(val, oldVal) {
        // console.log("old:" + val, "new:" + oldVal);
        this.getListData();
      },
      // deep: true, //true 深度监听
      // immediate: true,
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let that = this;
    let w = $(that.$refs.LC_progress).outerWidth();
    let h = $(that.$refs.LC_progress).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    this.getListData();
  },
  //方法集合
  methods: {
    async getListData() {
      try {
        const carbonReduceMeasures =
          CONFIG.requestName + this.$apiOpt.carbonReduceMeasures;
        const res = await this.$apiUtils.get(carbonReduceMeasures, {
          customerId: this.customerId,
          processId: this.processId || null,
        });
        this.dataList = res || [];
      } catch (err) {
        console.log(err);
      }
    },
    openDetail(data) {
      console.log("data", data);
      this.$store.commit("dialogStatus", true);
      this.$popup.open(progressDetailPage, this.dialogCompontent, null, {
        measureName: data.measureName,
        id: data.id,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.LC_progress {
  position: absolute;
  height: 100%;
  width: 600px;
  pointer-events: all;
  padding-top: 72px !important;
  overflow: hidden;
  .lookMore {
    position: absolute;
    color: #4be0ff;
    top: 23px;
    right: 23px;
    font-size: 18px;
    color: #4be0ff;
    cursor: pointer;
  }
  :deep(.el-collapse) {
    border: none;
    height: 100%;
    .el-collapse-item {
      margin-bottom: 3px;
      .el-collapse-item__header {
        background-color: transparent;
        width: 99% !important;
        @include bg-box(99%, 50px, "rowBg.png");
        padding: 0px 12px;
        border: none;
        .el-collapse-item__arrow {
          display: none;
        }
        .titleLine {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          .leftTitle {
            font-size: 20px;
            font-weight: 600;
            color: #fff;
            line-height: 50px;
          }
          .rightTitleBox {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .rightTitle {
              font-size: 18px;
              font-weight: 500;
              color: rgb(190, 210, 215);
              line-height: 50px;
              span {
                @extend .leftTitle;
                color: #f4c48f;
                margin: 0px 3px;
              }
            }
            .rightTitle2 {
              margin-left: 10px;
            }
          }
        }
      }
      .el-collapse-item__header.is-active {
        @include bg-box(560px, 50px, "activeRowBg.png");
        .leftTitle {
          color: #f4c48f;
        }
        .rightTitle {
          color: #99f5ff !important;
        }
      }

      .el-collapse-item__wrap {
        background-color: transparent !important;
        border: none;
        max-height: 600px;
        overflow: auto;
        /* 设置滚动条的样式 */
        &::-webkit-scrollbar {
          width: 8px;
        }
        /* 滚动条滑块 */
        &::-webkit-scrollbar-thumb {
          width: 8px;
          height: 258px;
          background: linear-gradient(180deg, #449eff 0%, #1e5cbb 100%);
          box-shadow: 2px 2px 4px 0px rgba(0, 36, 32, 0.5);
          border-radius: 4px;
        }
        .el-collapse-item__content {
          padding-bottom: 0px;
          .rowBox {
            height: 180px;
            cursor: pointer;
            &:hover {
              border: 1px solid #449eff;
            }
            .rowTitle {
              height: 40px;
              font-size: 16px;
              color: #dfdfdf;
              line-height: 40px;
              padding: 0px 12px;
              border: 1px solid rgba(132, 170, 255, 0.5);
            }
            .rowView {
              height: 140px;
              padding: 0px 12px;
              border: 1px solid rgba(132, 170, 255, 0.5);
              background: rgba(2, 26, 54, 0.2);
              .line1 {
                height: 110px;
                display: flex;
                justify-content: space-between;
                .l1box {
                  display: flex;
                  flex-direction: column;
                  justify-content: space-evenly;
                  .l1 {
                    font-size: 16px;
                    color: #f4c48f;
                    line-height: 47px;
                    text-align: right;
                    span {
                      color: #dfdfdf;
                    }
                    .number {
                      font-size: 24px;
                      color: #99f5ff;
                      margin: 0px 10px;
                    }
                  }
                  .l1_ {
                    margin-left: 10px;
                  }
                }

                .r1 {
                  font-size: 16px;
                  color: #dfdfdf;
                  line-height: 47px;
                  width: 40%;
                  margin: 15px 0;
                  background: rgba(21, 51, 96, 0.2);
                  text-align: center;
                  position: relative;
                  .number {
                    font-size: 50px;
                    color: rgb(255, 197, 102);
                    line-height: 80px;
                    margin-right: 10px;
                  }
                  .status {
                    position: absolute;
                    bottom: -14px;
                    right: 3px;
                  }
                }
              }
              .rowBottom {
                .allProgressLine {
                  height: 12px;
                  background: #010813;
                  box-shadow: 0px 0px 1px 0px #0b5563;
                  border-radius: 6px;
                  .alreadyLine {
                    width: 100px;
                    height: 10px;
                    background: linear-gradient(
                      270deg,
                      #bef9ff 0%,
                      #6b7ddd 100%
                    );
                    border-radius: 6px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
